import { render, staticRenderFns } from "./wavView.vue?vue&type=template&id=2db7fe48&scoped=true"
import script from "./wavView.vue?vue&type=script&lang=js"
export * from "./wavView.vue?vue&type=script&lang=js"
import style0 from "./wavView.vue?vue&type=style&index=0&id=2db7fe48&prod&lang=scss&scoped=true"
import style1 from "./wavView.vue?vue&type=style&index=1&id=2db7fe48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7fe48",
  null
  
)

export default component.exports